import { useState } from "react";
import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

export default function SisiAvatar({
  className,
  size = "md",
  online = false,
}) {
  const [imageError, setImageError] = useState(false);

  const sizes = {
    sm: "h-12 w-12",
    md: "h-14 w-14",
    lg: "h-16 w-16",
    xl: "h-24 w-24",
  };

  return (
    <div
      className={cn(
        "relative shrink-0 rounded-full",
        sizes[size] || sizes.md,
        className
      )}
    >
      <div className="h-full w-full overflow-hidden rounded-full border border-primary/20 bg-background shadow-sm">
        {!imageError ? (
          <img
            src="/sisi/sisi.png"
            alt="Sisi"
            onError={() => setImageError(true)}
            className="h-full w-full scale-[1.18] object-cover object-[50%_16%]"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-primary text-primary-foreground">
            <Sparkles className="h-5 w-5" />
          </div>
        )}
      </div>

      {online && (
        <span
          className="absolute bottom-0 right-0 h-3 w-3 rounded-full border-2 border-background bg-emerald-500"
          aria-label="Online"
        />
      )}
    </div>
  );
}
